import React from 'react';
import { useNavigate } from 'react-router';
import { Icon } from 'semantic-ui-react';
import { useAuth } from '../../../providers/AuthenticationProvider';
import './HeaderUserDropdown.css';

export const HeaderUserDropdown = ({ username }) => {
    const { logout, isDistributorAdmin } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="dropdown">
            <button className="dropbtn">{username} <Icon name="caret down" /></button>
            <div className="dropdown-content">
                {isDistributorAdmin() ? (
                    <button
                        onClick={() => {
                            navigate('/distributors/settings');
                        }}
                    >
                        Settings
                    </button>
                ) : null}
                <button
                    onClick={() => {
                        navigate('/users/change-password');
                    }}
                >
                    Change Password
                </button>
                <button
                    onClick={() => {
                        navigate('/');
                        logout();
                    }}
                >
                    Logout
                </button>
            </div>
        </div>
    );
};
